<template>
	<el-dialog title="详情" :visible.sync="planListShow" width="1200px" @close="close" center>
		<!--        <el-row>-->
		<!--            <el-col :span="24">-->
		<!--                <el-form ref="addForm" :model="addForm" label-width="80px">-->
		<!--                    <el-row>-->
		<!--                        <el-col :span="8">-->
		<!--                            <el-form-item label="计划名称">-->
		<!--                                <el-input :disabled="true" v-model="addForm.planTitle"></el-input>-->
		<!--                            </el-form-item>-->
		<!--                        </el-col>-->
		<!--                        <el-col :span="8">-->
		<!--                            <el-form-item label="开始时间">-->
		<!--                                <el-input :disabled="true" v-model="addForm.startTime"></el-input>-->
		<!--                            </el-form-item>-->
		<!--                        </el-col>-->

		<!--                        <el-col :span="8">-->
		<!--                            <el-form-item label="删除状态">-->
		<!--                                <el-input :disabled="true" v-model="addForm.deleteStatus == 0 ? '未删除' : '已删除'"></el-input>-->
		<!--                            </el-form-item>-->
		<!--                        </el-col>-->
		<!--                    </el-row>-->
		<!--                    <el-row>-->
		<!--                        <el-col :span="8">-->
		<!--                            <el-form-item label="结束时间">-->
		<!--                                <el-input :disabled="true" v-model="addForm.endTime"></el-input>-->
		<!--                            </el-form-item>-->
		<!--                        </el-col>-->
		<!--                        <el-col :span="8">-->
		<!--                            <el-form-item label="修改时间">-->
		<!--                                <el-input :disabled="true" v-model="addForm.updateTime"></el-input>-->
		<!--                            </el-form-item>-->
		<!--                        </el-col>-->
		<!--                    </el-row>-->
		<!--                </el-form>-->
		<!--            </el-col>-->
		<!--        </el-row>-->
		<el-row>
			<el-col :span="24">
				<div style="width: 100%" v-if="addForm.titleType == 4">
					<el-row>
						<el-col :span="4">序号</el-col>
						<el-col :span="20">关联活动内容</el-col>
					</el-row>
					<el-row>
						<el-col :span="4">01</el-col>
						<el-col :span="20">
							<div>
								<p>素材ID：{{ addForm.infoList[0].activityId }}</p>
								<p>素材名称：{{ addForm.infoList[0].activityName }}</p>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="4">02</el-col>
						<el-col :span="20">
							<el-table :data="addForm.infoList[1].goods" style="width: 100%">
								<el-table-column prop="productId" label="商品ID" width="180">
								</el-table-column>
								<el-table-column prop="productName" label="商品名称" width="180">
								</el-table-column>
								<el-table-column prop="productStartTime" label="上架时间" width="180">
								</el-table-column>
								<el-table-column prop="productEndTime" label="下架时间" width="180">
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="4"></el-col>
						<el-col :span="20">

						</el-col>
					</el-row>
				</div>
				<div v-else>
					<el-row>
						<el-table :data="addForm.infoList" style="width: 100%">
							<el-table-column type="index" width="70" label="序号"></el-table-column>
							<el-table-column prop="infoName" label="字段名称" width="180">
							</el-table-column>
							<el-table-column prop="dicType" label="类型" width="180">
							</el-table-column>
							<el-table-column prop="address" label="内容关联" width="600">
								<template slot-scope="scope">
									<!--                        课程-->
									<div v-if="scope.row.infoType == 8">
										<p>课程ID:{{ addForm.infoList[scope.$index].courseId }}</p>
										<p>课程名称:{{ addForm.infoList[scope.$index].courseName }}</p>
									</div>
									<div v-else-if="scope.row.infoType == 9">
										<el-row>
											<el-col span="24">
												<el-col span="24">
													<el-table :data="addForm.infoList[scope.$index].goods" border
														style="width: 100%">
														<el-table-column prop="productId" label="商品ID">
														</el-table-column>
														<el-table-column prop="productName" label="商品名称">
														</el-table-column>
														<el-table-column prop="productStartTime" label="开始时间">
														</el-table-column>
														<el-table-column prop="productEndTime" label="结束时间" width="180">
														</el-table-column>
													</el-table>

												</el-col>
											</el-col>
										</el-row>
									</div>
									<div v-else-if="scope.row.infoType == 10">
										<el-row>
											<el-input type="planInfo" :disabled="true"
												v-model="addForm.infoList[scope.$index].planInfo" maxlength="500"
												show-word-limit>
											</el-input>
										</el-row>
										<el-row>
											<!--                                图-->
											<el-row>
												<div style="display: inline-block;"
													v-for="(item, i) in addForm.infoList[scope.$index].planPics">
													<img v-if="item" style="width: 50px;height: 50px;" :src="item"
														class="avatar">
												</div>
											</el-row>
										</el-row>
									</div>
									<div v-else>
										<el-row>
											<quill-editor ref="myTextEditor"
												v-model="addForm.infoList[scope.$index].planInfo"
												:options="editorOption"></quill-editor>
										</el-row>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</el-row>

				</div>
			</el-col>
		</el-row>
		<span slot="footer" class="dialog-footer">
		</span>
	</el-dialog>
</template>


<script>
	export default {
		props: {
			addForm: {
				type: Object
			},
			planListShow: {
				type: Boolean,
				default: false
			}
		},
		mounted() {
			if (this.addForm.titleType == 4) {
				let newList = this.addForm.infoList
				let createList = [];
				newList.forEach((item, index) => {
					if (item.activityId != null) {
						this.addForm.infoList[0] = item
					} else if (item.activityId == null) {
						this.addForm.infoList[1] = item
					}
				})

			} else {

			}
		},
		data() {
			return {
				editorOption: {
					placeholder: '编辑文章内容'
				}
			}

		},
		methods: {
			close() {
				this.$emit('close', false)
				this.planListShow = false;
			}
		}
	}
</script>
